module.exports = __webpack_public_path__ + "img/xqgl3.854fa759.png";